module.exports = function(array) {
  return array.filter(function(item, index) {
    return array.indexOf(item) === index;
  });
};
